"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function parseBoolean(value) {
    if (typeof value === 'string') {
        switch (value.toLowerCase()) {
            case 'false':
                return false;
            case 'true':
                return true;
            default:
                return value;
        }
    }
    return value;
}
exports.default = parseBoolean;
